<ui-dialog
    size="small"
    header="applicant-tracker.deleteComment"
    [open]="isDeleteCommentDialogOpen"
    (primaryButtonPressed)="onDeleteComment()"
    (secondaryButtonPressed)="closeDeleteCommentDialogOpen()"
    deleteDialog
>
    <p>{{ 'applicant-tracker.areYouSureYouWantToDeleteThisComment' | appTranslate }}</p>
</ui-dialog>

<ui-card [loading]="isLoading">
    <app-segment-header title="applicant-tracker.components.comment.title"></app-segment-header>
    <div *ngFor="let discussion of applicantDiscussions">
        <app-discussion-comment
            [new]="true"
            [hiringTeam]="hiringTeam"
            (save)="onSaveComment($event, discussion)"
        ></app-discussion-comment>
        <app-discussion-comment
            id="comment-{{ comment.id }}"
            *ngFor="let comment of discussion.discussionComments"
            [comment]="comment"
            [hiringTeam]="hiringTeam"
            (save)="onSaveComment($event, discussion)"
            (delete)="openDeleteCommentDialogOpen(comment)"
        ></app-discussion-comment>
        <app-empty-state
            *ngIf="!discussion.discussionComments.length"
            src="/assets/illustrations/documents.png"
            label="applicant-tracker.beTheFirstToLeaveAComment"
        ></app-empty-state>
    </div>
</ui-card>
